import { defineComponent } from "vue";

export const AppRoot = defineComponent({
  mounted() {
    window.dispatchEvent(new Event("vueComponentRootMounted"));
  },
});
